import React from 'react';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image'
import mathsMore2 from './../documents/picturs/mathMore2.png';
import mathsMore1 from './../documents/picturs/mathsMore1.png';
import mathMore3 from './../documents/picturs/mathMore3.png';

import mathsMore4 from './../documents/picturs/mathsMore4.png';
import mathsMore5 from './../documents/picturs/mathsMore5.png';
import mathsMore6 from './../documents/picturs/mathMore6.png';

import Card from 'react-bootstrap/Card'
import 'bootstrap/dist/css/bootstrap.min.css'
import Alert from 'react-bootstrap/Alert'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
} from "react-router-dom";


// function MyCard({title, content}){
//   return(
//     <Card className="bg-dark text-dark">
//       <Card.Img src={mathsMore1} alt="Card image"/>
//
//
//           <Card.ImgOverlay>
//           <div className="d-block p-2 bg-primary text-white">
//
//             </div>
//           </Card.ImgOverlay>
//
//
//     </Card>
//   )
// }


class MoreContent extends React.Component{
  render(){
    return(
      <div>
      <Alert className="text-center mt-3 bg-warning" variant='warning'><h4 className="text-dark">مواضيع أخري  -  autres sujets</h4></Alert>
      <Row>
      <Col xs="12" md="6" sm="12" lg="4">
          <div className="pt-3 pb-3">
            <Link to="/maths/bac-2/science-experimentale/examen">
            <Image src={mathsMore1} style={{width:"100%", height:"100%"}} className="shadow-lg" thumbnail/>
            <h3 className="text-center">إمتحان وطني موسم 2018 علوم تجريبية</h3>
            </Link>
          </div>
      </Col>

        <Col xs="12" md="6" sm="12" lg="4">
            <div className="pt-3 pb-3">
              <Link to="/maths/bac-2/science-maths/examen">
              <Image src={mathsMore2} style={{width:"100%", height:"100%"}} className="shadow-lg" thumbnail/>
              <h3 className="text-center">شعبة العلوم الرياضية - إمتحان وطني - 2015</h3>
              </Link>
            </div>
        </Col>


        <Col xs="12" md="6" sm="12" lg="4">
            <div className="pt-3 pb-3">
              <Link to="/maths/3/devoirs">
              <Image src={mathMore3} style={{width:"100%", height:"100%"}} className="shadow-lg" thumbnail/>
              <h3 className="text-center">devoir pour le 3ème année secondaire</h3>
              </Link>
            </div>
        </Col>

      </Row>


      <Row>
      <Col xs="12" md="6" sm="12" lg="4">
          <div className="pt-3 pb-3">
            <Link to="/maths/3/devoirs">
            <Image src={mathsMore6} style={{width:"100%", height:"100%"}} className="shadow-lg" thumbnail/>
            <h3 className="text-center">Exercices pour le premiere année secondaire</h3>
            </Link>
          </div>
      </Col>

        <Col xs="12" md="6" sm="12" lg="4">
            <div className="pt-3 pb-3">
              <Link to="/maths/2/exercices">
              <Image src={mathsMore5} style={{width:"100%", height:"100%"}} className="shadow-lg" thumbnail/>
              <h3 className="text-center">Exercices pour le deuxième année secondaire</h3>
              </Link>
            </div>
        </Col>

        <Col xs="12" md="6" sm="12" lg="4">
            <div className="pt-3 pb-3">
              <Link to="/maths/3/exercices">
              <Image src={mathsMore4} style={{width:"100%", height:"100%"}} className="shadow-lg" thumbnail/>
              <h3 className="text-center">Exercices pour le toisième année secondaire</h3>
              </Link>
            </div>
        </Col>
      </Row>



      </div>
    );
  }
}

export default MoreContent;
